import React from 'react';

const IconVkontakte = () => {
  return (
    <div>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.495117" width="40" height="40" rx="8" fill="black" />
        <path
          d="M21.6115 27.7998C13.07 27.7998 8.19812 21.9441 7.99512 12.2002H12.2737C12.4142 19.352 15.5684 22.3813 18.0669 23.0059V12.2002H22.0958V18.3682C24.563 18.1028 27.1548 15.292 28.0292 12.2002H32.058C31.3866 16.0103 28.5758 18.8211 26.5771 19.9766C28.5758 20.9135 31.7771 23.3651 32.9951 27.7998H28.5602C27.6077 24.8329 25.2344 22.5375 22.0958 22.2252V27.7998H21.6115Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default IconVkontakte;
